import { DraftTextConfiguration, PrintArea, PrintType } from '@/types';
import { getScaleAndFontSize } from '@/model/configuration/getScaleAndFontSize';
import { updateFontSize } from './updateFontSize';

export function resizeTextToScale(
  configuration: DraftTextConfiguration,
  printArea: PrintArea,
  printType: PrintType,
  desiredScale: number
) {
  const { fontSize } = getScaleAndFontSize(
    configuration.text.style,
    configuration.rotation,
    configuration.size,
    printArea,
    printType,
    desiredScale
  );
  updateFontSize(configuration, fontSize);
}
